import { createReducer } from 'app-webtech-core/reducers/createReducer';
import uuid from 'uuid/v4';
import {
  LOADED,
  LOADING_ERROR,
  SET_ID,
  SET_SESSION_URL,
  SET_MARKETING_REGION,
  TRACK_EVENTS,
} from '../actions/types';
import { playbackSessionLoadReducer } from './load';
import { playbackSessionSetIDReducer } from './setID';
import { playbackSessionSetSessionUrlReducer } from './setSessionUrl';
import { playbackSessionSetMarketingRegionReducer } from './setMarketingRegion';
import { playbackSessionTrackEventsReducer } from './trackEvents';

export const defaultState = {
  ID: process.env.BOOTSTRAP_VERSION === 'v4' ? null : uuid(),
  marketingRegion: null,
  sessionUrl: null,
  nextUpdate: null,
  error: null,
  trackChannelEvents: true,
  trackClipEvents: true,
};

export const playbackSessionReducer = createReducer(defaultState, {
  [LOADED]: playbackSessionLoadReducer,
  [LOADING_ERROR]: playbackSessionLoadReducer,
  [SET_ID]: playbackSessionSetIDReducer,
  [SET_SESSION_URL]: playbackSessionSetSessionUrlReducer,
  [SET_MARKETING_REGION]: playbackSessionSetMarketingRegionReducer,
  [TRACK_EVENTS]: playbackSessionTrackEventsReducer,
});
